import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-title m-0" }
const _hoisted_6 = {
  key: 1,
  src: "/media/icons/duotune/arrows/gifrep.gif",
  alt: "Loading Icon",
  class: "loading-icon"
}
const _hoisted_7 = { class: "collapse show" }
const _hoisted_8 = { class: "card-body border-top p-9" }
const _hoisted_9 = { class: "row mb-12" }
const _hoisted_10 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_11 = { class: "col-lg-5" }
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-5" }
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "row mb-12" }
const _hoisted_19 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_20 = { class: "col-lg-5" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-5" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-12" }
const _hoisted_28 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-5 fv-row" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_33 = { class: "col-lg-5 fv-row" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "row mb-12" }
const _hoisted_37 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_38 = { class: "col-lg-5 fv-row" }
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_42 = { class: "col-lg-5 fv-row" }
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { class: "row mb-12" }
const _hoisted_46 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_47 = { class: "col-lg-5 fv-row" }
const _hoisted_48 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_49 = ["hidden", "value"]
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_53 = { class: "col-lg-5 fv-row" }
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "row mb-12" }
const _hoisted_57 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_58 = { class: "col-lg-5 fv-row" }
const _hoisted_59 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_60 = ["value"]
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_64 = { class: "col-lg-5 fv-row" }
const _hoisted_65 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_66 = ["value"]
const _hoisted_67 = { class: "fv-plugins-message-container" }
const _hoisted_68 = { class: "fv-help-block" }
const _hoisted_69 = { class: "row mb-12" }
const _hoisted_70 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_71 = { class: "col-lg-5 fv-row" }
const _hoisted_72 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "fv-plugins-message-container" }
const _hoisted_75 = { class: "fv-help-block" }
const _hoisted_76 = { class: "card-footer d-flex justify-content-center py-6 px-9" }
const _hoisted_77 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_78 = { class: "indicator-label" }
const _hoisted_79 = { class: "indicator-progress" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_SearchField = _resolveComponent("SearchField")!
  const _component_vue3_json_excel = _resolveComponent("vue3-json-excel")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'settings'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('HorseLessonReport')), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: "svg-icon svg-icon-1 ms-6",
              style: {"cursor":"pointer"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
            }, [
              (!_ctx.loadingPage)
                ? (_openBlock(), _createBlock(_component_inline_svg, {
                    key: 0,
                    src: "/media/icons/duotune/arrows/arr029.svg"
                  }))
                : _createCommentVNode("", true),
              (_ctx.loadingPage)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.print,
            "validation-schema": _ctx.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.translate('startDate')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Field, {
                      type: "date",
                      name: "startDate",
                      autocomplete: "off",
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startDate) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DatePicker, {
                          id: "startDate",
                          class: "form-control form-control-lg form-control-solid",
                          modelValue: _ctx.startDate,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startDate) = $event)),
                          placeholder: _ctx.translate('dd/mm/yyyy'),
                          fieldId: "startDate",
                          reset: true
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_ErrorMessage, { name: "startDate" })
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.translate('endDate')), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Field, {
                      type: "date",
                      name: "endDate",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('endDate'),
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DatePicker, {
                          id: "endDate",
                          class: "form-control form-control-lg form-control-solid",
                          modelValue: _ctx.endDate,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endDate) = $event)),
                          placeholder: _ctx.translate('dd/mm/yyyy'),
                          fieldId: "endDate",
                          reset: true
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_ErrorMessage, { name: "endDate" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.translate('startTime')), 1),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_Field, {
                      type: "time",
                      name: "startTime",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('startTime'),
                      modelValue: _ctx.startTime,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.startTime) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_ErrorMessage, { name: "startTime" })
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('endTime')), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_Field, {
                      type: "time",
                      name: "endTime",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('endTime'),
                      modelValue: _ctx.endTime,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.endTime) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_ErrorMessage, { name: "endTime" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('customer')), 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_Field, {
                      name: "customerId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedCustomer,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedCustomer) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SearchField, {
                          modelValue: _ctx.selectedCustomer,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedCustomer) = $event)),
                          options: _ctx.customers,
                          mode: "single",
                          label: _ctx.translate('Select Customer'),
                          className: "form-select-md"
                        }, null, 8, ["modelValue", "options", "label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_ErrorMessage, { name: "customerId" })
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.translate('trainer')), 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_Field, {
                      name: "trainerId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedTrainer,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedTrainer) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SearchField, {
                          modelValue: _ctx.selectedTrainer,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedTrainer) = $event)),
                          options: _ctx.trainers,
                          mode: "single",
                          label: _ctx.translate('Select Trainer'),
                          className: "form-select-md"
                        }, null, 8, ["modelValue", "options", "label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_ErrorMessage, { name: "trainerId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.translate('Horse')), 1),
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_Field, {
                      name: "horseId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedHorse,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedHorse) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SearchField, {
                          modelValue: _ctx.selectedHorse,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedHorse) = $event)),
                          options: _ctx.horses,
                          mode: "single",
                          label: _ctx.translate('Select Horse'),
                          className: "form-select-md",
                          trackBy: "nameEn"
                        }, null, 8, ["modelValue", "options", "label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_ErrorMessage, { name: "horseId" })
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.translate('arena')), 1),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_Field, {
                      name: "arenaId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedArena,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedArena) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SearchField, {
                          modelValue: _ctx.selectedArena,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedArena) = $event)),
                          options: _ctx.arenas,
                          mode: "single",
                          label: _ctx.translate('Select Arena'),
                          className: "form-select-md"
                        }, null, 8, ["modelValue", "options", "label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_ErrorMessage, { name: "arenaId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.translate('duration')), 1),
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "durationId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selecteDuration,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selecteDuration) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_48, _toDisplayString(_ctx.translate('select Duration')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.durationList, (duration) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: duration.id,
                            hidden: duration.slug == 60 || duration.slug == 15,
                            value: duration.id
                          }, _toDisplayString(duration.nameEn), 9, _hoisted_49))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_ErrorMessage, { name: "durationId" })
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.translate('groomer')), 1),
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_Field, {
                      name: "groomerId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedGroomer,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedGroomer) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SearchField, {
                          modelValue: _ctx.selectedGroomer,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedGroomer) = $event)),
                          options: _ctx.groomers,
                          mode: "single",
                          label: _ctx.translate('Select Groomer'),
                          className: "form-select-md"
                        }, null, 8, ["modelValue", "options", "label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_component_ErrorMessage, { name: "groomerId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.translate('Type')), 1),
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "typeId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selecteType,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selecteType) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_59, _toDisplayString(_ctx.translate('select Type')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classType, (type) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: type.id,
                            value: type.id
                          }, _toDisplayString(type.nameEn), 9, _hoisted_60))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_ErrorMessage, { name: "typeId" })
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.translate('day')), 1),
                  _createElementVNode("div", _hoisted_64, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "dayId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedDay,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selectedDay) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_65, _toDisplayString(_ctx.translate('select Day')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayList, (day) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: day.id,
                            value: day.id
                          }, _toDisplayString(day.nameEn), 9, _hoisted_66))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_ErrorMessage, { name: "dayId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.translate('attendance')), 1),
                  _createElementVNode("div", _hoisted_71, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "attendanceId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedAttendance,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectedAttendance) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_72, _toDisplayString(_ctx.translate('select Attendance')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (status) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: status.id,
                            value: status.id
                          }, _toDisplayString(status.nameEn), 9, _hoisted_73))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createVNode(_component_ErrorMessage, { name: "attendanceId" })
                      ])
                    ])
                  ])
                ])
              ]),
              _createTextVNode(" . "),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_77, [
                  _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.translate('Print as pdf')), 1),
                  _createElementVNode("span", _hoisted_79, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_80
                  ])
                ], 512),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light-primary mx-3",
                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.printExcel && _ctx.printExcel(...args)))
                }, _toDisplayString(_ctx.translate('Print as excel')), 1),
                (_ctx.excelData)
                  ? (_openBlock(), _createBlock(_component_vue3_json_excel, {
                      key: 0,
                      ref: "jsonExcel",
                      "json-data": _ctx.excelData,
                      fields: _ctx.excelHeader,
                      worksheet: "Horse Lessons WorkSheet",
                      name: "horse_count_report.xls"
                    }, null, 8, ["json-data", "fields"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}